// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"3efe3e65","795":"36fe3cb6"}[chunkId] + ".chunk.js";
};